<template>
  <a-layout id="components-layout-demo-top-side-2">
    <Sider />
    <a-layout>
      <Header></Header>
      <a-layout :style="{ padding: '40px 40px 20px 40px' }" class="bodyContnet" id="bodyContnet">
        <a-layout-content
          class="components-layout-content"
          id="components-layout-content"
          :style="{
            padding: '0px',
            overflowY: 'auto',
            overflowX: 'hidden',
            height: '100%',
          }"
        >
          <keep-alive>
            <router-view v-if="$route.meta.keepAlive"></router-view>
          </keep-alive>
          <router-view v-if="!$route.meta.keepAlive"></router-view>
        </a-layout-content>
      </a-layout>
    </a-layout>
  </a-layout>
</template>

<script>
import Sider from "./sider";
import Header from "./header";
export default {
  components: {
    Sider,
    Header,
  },
};
</script>

<style scoped>
#components-layout-demo-top-side-2 {
  height: 100vh;
  overflow: hidden;
}
/* #components-layout-demo-responsive .logo {
  height: 32px;
  background: rgba(255, 255, 255, 0.2);
} */

.components-layout-content::-webkit-scrollbar {
  display: none;
}

#components-layout-content::-webkit-scrollbar {
  width: 4px;
}

#components-layout-content::-webkit-scrollbar-thumb {
  /*正在滑动的小块*/
  border-radius: 10px;
  background-color: rgba(192, 192, 192, 0.3);
  margin-right: 2px;
}

#components-layout-content::-webkit-scrollbar-track {
  /*滚动内部轨道*/
  /* box-shadow: inset 0 0 5px rgba(186, 32, 32, 0.2); */
  background: transparent;
  /* border-radius: 10px; */
}
/* .components-layout-content{
  background: red;
} */

#bodyContnet {
  width: 100%;
  height: 100%;
}
</style>